import { byFrequency, RecurringFrequency } from "@repo/shared/types";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./frequency-suffix.i18n";

/** Returns a formatter for the "/month" style suffix of a recurring frequency. */
export function useFrequencySuffix(): (frequency: string) => string {
  const t = useT(T);
  return (frequency) =>
    byFrequency(frequency, {
      [RecurringFrequency.MONTHLY]: t.perMonth,
      [RecurringFrequency.QUARTERLY]: t.perQuarter,
      [RecurringFrequency.YEARLY]: t.perYear,
    });
}
